import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-error" }
const _hoisted_8 = { class: "col-lg-4 col-sm-6" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = {
  key: 0,
  class: "input-error"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-2 col-sm-6" }
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = { class: "input-error" }
const _hoisted_15 = { class: "col-lg-2 col-sm-6" }
const _hoisted_16 = { class: "form-group mb-4" }
const _hoisted_17 = { class: "input-error" }
const _hoisted_18 = { class: "col-lg-4 col-sm-6" }
const _hoisted_19 = { class: "form-group mb-4" }
const _hoisted_20 = { class: "input-error" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-lg-8 col-sm-6" }
const _hoisted_23 = { class: "form-group mb-4" }
const _hoisted_24 = {
  key: 0,
  class: "input-error"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-12" }
const _hoisted_27 = { class: "form-group mb-4" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "input-error" }
const _hoisted_31 = { class: "col-lg-12" }
const _hoisted_32 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_36 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_FilePond = _resolveComponent("FilePond")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.itemsTournament)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label text-secondary" }, "Torneo", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.match.tournamentId) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('tournamentId')))
                  }, [
                    _cache[15] || (_cache[15] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsTournament, (tourney, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: tourney.id,
                        key: i
                      }, _toDisplayString(tourney.name), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.match.tournamentId]
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errors.tournamentId), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre del partido",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.match.name) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('name')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.match.name]
              ]),
              (_ctx.errors.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errors.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label text-secondary" }, "Fecha Inicio", -1 /* HOISTED */)),
              _createVNode(_component_VueDatePicker, {
                placeholder: "Fecha y hora",
                modelValue: _ctx.match.startDate,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.match.startDate) = $event)),
                format: "dd/MM/yyyy HH:mm",
                "format-locale": _ctx.es,
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('startDate'))),
                "minutes-increment": 30,
                "enable-time-picker": true,
                "is-24": "",
                teleport: ""
              }, null, 8 /* PROPS */, ["modelValue", "format-locale"]),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.errors.startDate), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label text-secondary" }, "Fecha Fin", -1 /* HOISTED */)),
              _createVNode(_component_VueDatePicker, {
                placeholder: "Fecha y hora",
                modelValue: _ctx.match.endDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.match.endDate) = $event)),
                format: "dd/MM/yyyy HH:mm",
                "format-locale": _ctx.es,
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('endDate'))),
                "minutes-increment": 30,
                "is-24": "",
                teleport: ""
              }, null, 8 /* PROPS */, ["modelValue", "format-locale"]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.errors.endDate), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label text-secondary" }, "Título", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el título del torneo",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.match.title) = $event)),
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('title')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.match.title]
              ]),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.errors.title), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar la descripción del torneo",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.match.description) = $event)),
                onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('name')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.match.description]
              ]),
              (_ctx.errors.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.errors.description), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label text-secondary" }, "Portada", -1 /* HOISTED */)),
              (_ctx.match.urlCoverPhoto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("img", {
                      src: _ctx.match.urlCoverPhoto,
                      alt: "Portada de Torneo",
                      class: "img-fluid mb-2 d-block"
                    }, null, 8 /* PROPS */, _hoisted_29),
                    _createElementVNode("button", {
                      onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeCoverFile && _ctx.removeCoverFile(...args)), ["prevent"])),
                      class: "btn btn-danger"
                    }, "Eliminar portada")
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.match.urlCoverPhoto)
                ? (_openBlock(), _createBlock(_component_FilePond, {
                    key: 1,
                    name: "fileCover",
                    maxFileSize: '2MB',
                    "accepted-file-types": _ctx.supportedFormats,
                    "allow-multiple": "false",
                    "max-files": 1,
                    "label-idle": "Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>",
                    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
                    labelMaxFileSize: 'El tamaño máximo permitido es {filesize}',
                    labelFileTypeNotAllowed: 'El archivo tiene una extensión no permitida',
                    fileValidateTypeLabelExpectedTypes: `Los tipos de archivo permitidos son: ${_ctx.supportedFormats.join(', ')}`,
                    credits: "",
                    onUpdatefiles: _ctx.handleUpdateFiles,
                    onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.clearError('fileCover')))
                  }, null, 8 /* PROPS */, ["accepted-file-types", "fileValidateTypeLabelExpectedTypes", "onUpdatefiles"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.errors.fileCover), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_RouterLink, { to: "/matches" }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.match.id == 0 ? 'Crear Partido' : 'Actualizar Partido'), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_33)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}